import axios from "axios";
import { CONVERSATIONS_ITEM_ACCEPT } from "./type";
import { STATUS_PERSON, DEAL_STATUS } from "constants/chatConstants";
import { CHAT_CONVERSATION } from "endpointsConst";

export function acceptConversationItem(conversationId, item, isMyEntity, lang) {
    const { type, id, conversation_entity_id } = item;

    return async (dispatch) => {
        try {
            await axios
                .patch(
                    `${CHAT_CONVERSATION}/${conversationId}/${conversation_entity_id}/accept/${id}`,
                    null,
                    {
                        params: {
                            type,
                            lang,
                        },
                    },
                )
                .then(() => {
                    const status_name = isMyEntity
                        ? STATUS_PERSON.OWNER_STATUS
                        : STATUS_PERSON.CLIENT_STATUS;
                    dispatch({
                        type: CONVERSATIONS_ITEM_ACCEPT,
                        payload: {
                            conversation_id: conversationId,
                            type,
                            type_id: id,
                            status_name,
                            status: DEAL_STATUS.ACCEPTED,
                            isMyChanges: true,
                        },
                    });
                });
        } catch (error) {
            // TODO handle error
        }
    };
}
